export const WORKOUT_STATUSES = [
    'planned',
    'completed',
    'canceled',
    'skipped',
];
//# sourceMappingURL=types.js.map